module.exports = __webpack_public_path__ + "src/assets/sounds/fire_sound.mp3";